// Hand-written companion to the codegen output in `./units.ts`.
//
// `rtk-openapi.recalc.config.cjs` only lists `units.ts` (and its sibling
// endpoint files) as `outputFiles`, so re-running the recalc OpenAPI codegen
// never touches this file - customizations here survive regeneration.
//
// `POST /Units` replies `201 Created` with an empty body; the new unit's id
// is only exposed via the `Location` response header. The codegen can't
// express header-derived data (its declared response type is a bare
// `object`), so we patch `unitsPostAsyncByunit`'s `transformResponse` here at
// runtime - mirroring `accounts.enhanced.ts` and what the old hand-written
// `src/api/recalc/endpoints/unitsApiSlice.jsx` `postUnit` mutation used to do.
import { recalcOpenApi } from './units';

export * from './units';

/** Runtime shape returned by the patched `unitsPostAsyncByunit` mutation. The
 * codegen's own `UnitsPostAsyncByunitApiResponse` type (`object`) can't
 * express this, so callers need to cast, e.g.
 * `(await createUnit(...).unwrap()) as UnitsPostAsyncByunitEnhancedResponse`. */
export type UnitsPostAsyncByunitEnhancedResponse = {
  data: object;
  /** New unit id parsed from the `Location` header, e.g. "42". */
  unitId: string | null;
};

// `unitsPutImageAsyncByidfile`'s generated `query()` passes the `body` arg
// (a plain `{ file: Blob }` object) straight through as the fetch body.
// `fetchBaseQuery` JSON-stringifies non-FormData bodies, which serializes a
// `Blob` to `{}` - an empty JSON payload - causing the API to reject the
// request with a 400 "Payload was empty" error. This override rebuilds the
// body as multipart `FormData`, mirroring what the old hand-written
// `src/api/recalc/endpoints/unitsApiSlice.jsx` `uploadUnitImage` mutation
// used to do (see also `gateways.enhanced.ts` for the same fix).
const enhancedRecalcUnitsApi = recalcOpenApi.enhanceEndpoints({
  endpoints: {
    unitsPostAsyncByunit: {
      transformResponse: (response, meta) => {
        const location = meta?.response?.headers.get('Location') ?? null;
        const unitId = location ? location.split('/').pop() : null;
        return { data: response, unitId };
      },
    },
    unitsPutImageAsyncByidfile: {
      query: (queryArg) => {
        const form = new FormData();
        form.append('file', queryArg.body.file);
        return {
          url: `/Units/${queryArg.id}/Image`,
          method: 'PUT',
          body: form,
        };
      },
    },
  },
});

export const {
  useUnitsPostAsyncByunitMutation,
  useUnitsPutImageAsyncByidfileMutation,
} = enhancedRecalcUnitsApi;
